import * as yup from "yup";
import {string} from "yup";
import i18n from "i18next";

class AdminRequestAttestApprovedModel {
    constructor({
                    id = '',
                    attested = '',
                    comment = '',

                } = {}) {
        this.id = id;
        this.attested = attested;
        this.comment = comment;
    }

    static getAttributes(filter = null, validationSchema = null, optionsData = null) {

        const completeSchema = yup.object().shape({
            id: string().required(''),
        });

        const attributes = {
            id :{
                'label': 'Id',
                'form': {
                    'type': 'text',
                    'placeholder': 'Enter Id',
                    // 'validation': completeSchema.Fields.role,
                },
                'value': (item) => item.id || "",
            },
            comment :{
                'label': i18n.t('modelLabel.comment'),
                'form': {
                    'type': 'textarea',
                    'placeholder': i18n.t('formPlaceholder.approveComment'),
                },
                'value': (item) => item.comment || "",
            },
            attested :{
                'label': 'Attested',
                'form': {
                    'type': 'text',
                    'placeholder': 'Enter Attested',
                    //'validation': completeSchema.Fields.permissions,
                },
                'value': (item) => item.attested || "",
            },

        }

        if (validationSchema === true) {
            return completeSchema;
        }

        return attributes;
    }
}
export default AdminRequestAttestApprovedModel;